import { render, staticRenderFns } from "./OrderCompleted.vue?vue&type=template&id=2859974c&scoped=true&"
import script from "./OrderCompleted.vue?vue&type=script&lang=ts&"
export * from "./OrderCompleted.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCompleted.vue?vue&type=style&index=0&id=2859974c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2859974c",
  null
  
)

export default component.exports